import { environment } from "@/config/env";
import { useEliteStructure } from "@/contexts/EliteTemporaryContextProvider";
import axios from "axios";
import { use, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function StructureLogin() {
  const { setStructureData } = useEliteStructure();
  const routeParams = useParams<{ id: string }>();
  const navigate = useNavigate();
  useDocumentTitle("Accesso Struttura");

  useEffect(() => {
    axios
      .get(
        `${environment.ELITE_BASE_URI}/webcheckin/structure/${routeParams.id}`,
      )
      .then((res) => {
        setStructureData(res.data.structureContextData);
        navigate("/", { replace: true });
      })
      .catch((err) => {
        toast.error("Errore nel recupero della struttura");
      });
  }, []);

  return (
    <>
      <Toaster />
    </>
  );
}
